/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { NgModule }             from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PagesComponent }       from "./pages.component";


const routes: Routes = [{
	path: '',
	component: PagesComponent,
	children: [
		{
			path: 'general',
			loadChildren: () => import('src/app/pages/general/theme-general.module')
                    .then(m => m.ThemeGeneralModule)
		},
		{
			path: 'tur',
			loadChildren: () => import('src/app/pages/tur/theme-tur.module')
                    .then(m => m.ThemeTurModule)
		}
	]
}];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PagesRoutingModule {

}
